import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import HomeServices from "../../Services/HomeServices";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const ManageStaff = () => {
  const [staffs, setStuffs] = useState([]);
  const [editStaffId, setEditStaffId] = useState("");
  const [fetchAllStaffLoading, setFetchAllStaffLoading] = useState(false);
  const [updateStaffLoading, setUpdateStaffLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [filteredStaffs, setFilteredStaffs] = useState([]);
  const [editStaffDetails, setEditStaffDetails] = useState({
    name: "",
    address: "",
    password: "",
    phoneNo: null,
    email: "",
  });

  const navigate = useNavigate();

  const fetchAllStuffs = async () => {
    try {
      setFetchAllStaffLoading(true);
      // Call your API function
      const response = await HomeServices.getAllStaffs();
      console.log("Amit", response);
      if (response && response?.status) {
        setStuffs(response?.data);
        setFetchAllStaffLoading(false);
      }
    } catch (error) {
      console.error("Error fetching Staffs :", error);
      setFetchAllStaffLoading(false);
    }
  };

  useEffect(() => {
    fetchAllStuffs();
  }, []);

  const findStaff = (id) => {
    const res = staffs.find((element) => {
      return element?._id == id;
    });
    setEditStaffDetails((prev) => ({
      ...prev,
      name: res?.name,
      email: res?.email,
      address: res?.address,
      phoneNo: res?.phoneNo,
      password: res?.passwordView,
    }));
  };

  const handleChange = (e) => {
    setEditStaffDetails((prev) => ({
      ...prev,
      [e?.target?.name]: e?.target?.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !editStaffDetails?.name ||
      !editStaffDetails?.address ||
      !editStaffDetails?.email ||
      !editStaffDetails?.phoneNo
    )
      return toast.error("Please fill all the fields!");
    setUpdateStaffLoading(true);
    await HomeServices.updateStaff(editStaffId, editStaffDetails)
      .then((res) => {
        if (res && res?.status) {
          toast.success("update successfully");
          // setEditStaffDetails(initValue);
          setEditStaffId("");
          setUpdateStaffLoading(false);
          fetchAllStuffs();
        } else {
          toast.error(res?.message || "Failed to update");
          setUpdateStaffLoading(false);
        }
      })
      .catch((err) => {
        toast.error(err?.message || "An error occurred");
        setUpdateStaffLoading(false);
        console.error("err", err);
      });
  };

  const handleDeleteStaff = async (id) => {
    console.log("deleteblogid", id);
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      console.log("result", result);
      if (result?.isConfirmed) {
        HomeServices.deleteStaff(id)
          .then((res) => {
            if (res && res.status) {
              toast.success("Deleted Successfully");
              fetchAllStuffs();
            } else {
              toast.error(res?.message);
            }
          })
          .catch((err) => {
            console.error("Error deleting document:", err);
          });
      } else {
        console.log("Deletion canceled");
      }
    });
  };

  const filterStaff = () => {
    const result = staffs.filter((element) => {
      return (
        element?.name?.toLowerCase().includes(filterText?.toLowerCase()) ||
        element?.email?.toLowerCase().includes(filterText?.toLowerCase()) ||
        element?.phoneNo
          ?.toString()
          ?.toLowerCase()
          .includes(filterText?.toLowerCase())
      );
    });
    setFilteredStaffs(result);
  };

  useEffect(() => {
    filterStaff();
  }, [filterText]);

  const columns = [
    { name: "SL No.", cell: (row, index) => index + 1, sortable: true },
    { name: "Name", selector: "name", wrap: true },
    { name: "Address", selector: "address", wrap: true },
    { name: "Phone Number", selector: "phoneNo", wrap: true },
    { name: "Email", selector: "email", wrap: true },
    { name: "Password", selector: "passwordView", wrap: true },
    {
      name: "Action",
      selector: (row) => (
        <div>
          <button
            style={{
              padding: "7px",
              backgroundColor: "#067d6b",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
            onClick={() => {
              navigate("/view-users-for-staff", {
                state: {
                  data: row,
                },
              });
            }}
          >
            View Users
          </button>
        </div>
      ),
      wrap: true,
    },
    {
      name: "Operations",
      selector: (row) => (
        <div>
          {/* <button
            style={{
              padding: "7px",
              backgroundColor: "#067d6b",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
          >
            View Users
          </button> */}
          <span
            onClick={() => {
              findStaff(row?._id);
              setEditStaffId(row?._id);
            }}
          >
            <i
              className="fa-regular fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "10px",
                fontSize: "1.5em",
                color: " #477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          <span
            onClick={() => {
              handleDeleteStaff(row?._id);
            }}
          >
            <i
              className="fa-regular fa-trash-can"
              style={{
                cursor: "pointer",
                marginRight: "10px",
                padding: "5px",
                fontSize: "1.5em",
                color: "#C4554D",
                backgroundColor: "#FAECEC",
              }}
            ></i>
          </span>
        </div>
      ),
      wrap: true,
    },
  ];

  // const data = [
  //   {
  //     sln: "1",
  //     name: "Amit Roy",
  //     address: "171/d, kandhiwali, Mumbai-158796",
  //     phoneNumber: "1234567890",
  //     email: "abc@gmail.com",
  //     password: "125698745",
  //   },
  //   {
  //     sln: "2",
  //     name: "Amit Roy",
  //     address: "171/d, kandhiwali, Mumbai-158796",
  //     phoneNumber: "1234567890",
  //     email: "abc@gmail.com",
  //     password: "125698745",
  //   },
  // ];
  return (
    <>
      {editStaffId && (
        <div className="d-flex justify-content-end mt-5">
          <div className="form-header">
            <section className="piechartsBox_area">
              {/* <BackPageBtn backLink="/" /> */}

              <form
                onSubmit={(e) => {
                  handleSubmit(e);
                }}
              >
                <div>
                  <h1 style={{ color: "#ff9c00" }}>Update Staff</h1>
                </div>

                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      name="name"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={editStaffDetails?.name}
                      // onChange={(e) => {
                      //   setFormValue({ ...formValue, document: e.target.value });
                      // }}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Address</label>
                    <textarea
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      style={{ resize: "none" }}
                      type="text"
                      className="form-control h-75"
                      placeholder="Enter Address"
                      name="address"
                      value={editStaffDetails?.address}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Phone Number</label>
                    <input
                      // onChange={(e) => {
                      //   handleChange(e);
                      // }}
                      type="text"
                      className="form-control"
                      placeholder="Enter Phone Number"
                      name="phoneNo"
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          setEditStaffDetails((prev) => ({
                            ...prev,
                            phoneNo: Number(e.target.value),
                          }));
                        }
                      }}
                      value={editStaffDetails?.phoneNo}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Email</label>
                    <input
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Enter Email"
                      name="email"
                      value={editStaffDetails?.email}
                      // onChange={(e) => {
                      //   setFormValue({ ...formValue, document: e.target.value });
                      // }}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <label htmlFor="formGroupExampleInput">Password</label>
                    <input
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Enter Password"
                      name="password"
                      value={editStaffDetails?.password}
                    />
                  </div>
                </div>

                {/* <div className="row mt-5">
                <div className="col-md-12">
                  <label htmlFor="formGroupExampleInput">Description</label>
                  <textarea
                    className="form-control"
                    rows={6}
                    name="description"
                    value={formValue?.description}
                    onChange={(e) => { setFormValue({ ...formValue, description: e.target.value }) }}
                  ></textarea>
                </div>
              </div> */}
                <div>
                  <button
                    disabled={updateStaffLoading}
                    type="submit"
                    //   onClick={(e) => handleSubmit(e)}
                    class="btn btn-primaryb mt-5 mb-4 addBlogBn"
                    style={{
                      background: "linear-gradient(195deg, #FFB14C, #ff9000)",
                      color: "#fff",
                    }}
                  >
                    {updateStaffLoading ? "Updating..." : "Update"}
                    {/* Update */}
                  </button>
                  <button
                    disabled={updateStaffLoading}
                    class="btn  mt-5 mb-4 "
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      // marginTop: "10px",
                      marginLeft: "10px",
                      border: "none",
                    }}
                    type="button"
                    onClick={(e) => setEditStaffId("")}
                    // class="btn btn-primaryb mt-3"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editStaffId && (
        <div className="d-flex justify-content-end mt-5">
          <div className="form-header" style={{ marginTop: "40px" }}>
            <div>
              <div>
                <section className="piechartsBox_area">
                  <div>
                    <div className="dateListDiv">
                      <h1
                        style={{
                          color: "#ff9c00",
                          fontSize: "25px",
                          fontWeight: "600",
                          marginBottom: "10px",
                        }}
                      >
                        Manage Staff
                      </h1>
                    </div>
                  </div>
                  <div>
                    <input
                      placeholder="Filter with Name, Phone No. & Email"
                      type="text"
                      value={filterText}
                      onChange={(e) => {
                        setFilterText(e.target.value);
                      }}
                      style={{
                        width: "20rem",
                        height: "30px",
                        backgroundColor: "#f5c778",
                        border: "none",
                        borderRadius: "8px",
                        padding: "0 10px",
                      }}
                    />
                  </div>

                  <hr />
                  <DataTable
                    columns={columns}
                    // data={staffs}
                    data={filterText ? filteredStaffs : staffs}
                    progressPending={fetchAllStaffLoading}
                    pagination
                  />
                </section>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageStaff;
